// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__FwQ-Z","loader":"Loader_loader__Jzxn1","loader_animation":"Loader_loader_animation__b71xU"};